module.exports = __webpack_public_path__ + "media/images/pullup-30a8f645268dfd4875bd57e14059d23f.png";